import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { Link } from 'react-router-dom'

const styles = {
  linkStyle: {
    textDecoration: 'none'
  }
};

const Item = props => {
  return (
    <ListItem button key={props.itemName} onClick={() => props.onHandleDrawerClose(props.itemName)}>
      <ListItemIcon>
        {props.icon}
      </ListItemIcon>
      <Link to={props.link} style={styles.linkStyle}>
        <ListItemText primary={props.itemName} />
      </Link>
    </ListItem>
  )
};

export default Item
